import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const VMA_HOME_LOAN_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('VMA_HOME_LOAN_ENABLED');

export const VMA_HOME_LOAN_USER: InjectionToken<Observable<boolean>> =
  new InjectionToken<Observable<boolean>>('VMA_HOME_LOAN_USER');

export const VMA_UPDATE_BOOK_TRAVEL_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('VMA_UPDATE_BOOK_TRAVEL_ENABLED');

export const VMA_VOX_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('VMA_VOX_ENABLED');

export const VMA_REBRANDING_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('VMA_REBRANDING_ENABLED');

export const VMA_VOP_VOX_OFFERS_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('VMA_VOP_VOX_OFFERS_ENABLED');

export const VMA_VOX_SHOP_EARN_BUTTON_UNLEASH_KEY = 'vma_vox_shop_earn_button';
export const VMA_VOX_SHOP_EARN_BUTTON_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('VMA_VOX_SHOP_EARN_BUTTON_ENABLED');

export const VMA_VOX_NEW_CATEGORY_MAPPING_UNLEASH_KEY =
  'vma_vox_new_category_mapping';
export const VMA_VOX_NEW_CATEGORY_MAPPING_ENABLED: InjectionToken<boolean> =
  new InjectionToken<boolean>('VMA_VOX_NEW_CATEGORY_MAPPING_ENABLED');
